import * as actions from "./actions"
import initializers from "./initializers"
import initialState from "./initialState"
import * as derivedState from "./derivedState"
import createStore, { consoleLogger } from "react-evoke"

export const logger = (action, info) => {
  if (window && window.app && window.__isAppLogging) {
    return consoleLogger(action, info)
  } else {
    return (store, ...payload) => action(store, ...payload)
  }
}

if (process.env.NODE_ENV !== "production") {
  if (window) {
    window.__isAppLogging = true
  }
}

export const { UseStore, Store, ErrorBoundary, useStore } = createStore({
  actions,
  initializers,
  initialState,
  derivedState,
  setup: "setup",
  teardown: "teardown",
  middleware: [logger],
  meta: {
    appId:
      process.env.REACT_APP_APP_ID || "c9b81a76-f4c2-4c2b-87c0-eca16c3f7c9f",
    channelId:
      process.env.REACT_APP_CHANNEL_ID || "d426c843-6602-431a-b79e-198afaa4769d"
  }
})
